// Auto-generated base dictionaries from @aws-amplify/ui authenticator locales
// Extended with Polish error messages missing from the official pl dictionary

export const amplifyAuthBaseEn = {
  "Account recovery requires verified contact information": "Account recovery requires verified contact information",
  "Back to Sign In": "Back to Sign In",
  "Change Password": "Change Password",
  "Confirm Password": "Confirm Password",
  "Confirm Sign Up": "Confirm Sign Up",
  "Confirm SMS Code": "Confirm SMS Code",
  "Confirm TOTP Code": "Confirm TOTP Code",
  "Confirmation Code": "Confirmation Code",
  "Create a new account": "Create a new account",
  "Create Account": "Create Account",
  "Creating Account": "Creating Account",
  "Dismiss alert": "Dismiss alert",
  "Enter your code": "Enter your code",
  "Enter your email": "Enter your email",
  "Enter your phone number": "Enter your phone number",
  "Enter your username": "Enter your username",
  "Forgot password?": "Forgot password?",
  "Forgot your password?": "Forgot your password?",
  "Hide password": "Hide password",
  "It may take a minute to arrive": "It may take a minute to arrive",
  "New password": "New password",
  "Phone Number": "Phone Number",
  "Resend Code": "Resend Code",
  "Reset your password": "Reset your password",
  "Reset your Password": "Reset your Password",
  "Send code": "Send code",
  "Send Code": "Send Code",
  "Setup TOTP": "Setup TOTP",
  "Show password": "Show password",
  "Sign in to your account": "Sign in to your account",
  "Sign In with Amazon": "Sign In with Amazon",
  "Sign In with Apple": "Sign In with Apple",
  "Sign In with Facebook": "Sign In with Facebook",
  "Sign In with Google": "Sign In with Google",
  "Sign in": "Sign in",
  "Sign In": "Sign In",
  "Signing in": "Signing in",
  "Verify Contact": "Verify Contact",
  "We Emailed You": "We Emailed You",
  "We Sent A Code": "We Sent A Code",
  "We Texted You": "We Texted You",
  "Your code is on the way. To log in, enter the code we emailed to": "Your code is on the way. To log in, enter the code we emailed to",
  "Your code is on the way. To log in, enter the code we sent you": "Your code is on the way. To log in, enter the code we sent you",
  "Your code is on the way. To log in, enter the code we texted to": "Your code is on the way. To log in, enter the code we texted to",
  "An account with the given email already exists.": "An account with the given email already exists.",
  "Confirm a Code": "Confirm a Code",
  "Confirm Sign In": "Confirm Sign In",
  "Create account": "Create account",
  "Enter your password": "Enter your password",
  "Forgot Password": "Forgot Password",
  "Have an account? ": "Have an account? ",
  "Incorrect username or password": "Incorrect username or password",
  "Incorrect username or password.": "Incorrect username or password.",
  "Invalid password format": "Invalid password format",
  "Invalid phone number format": "Invalid phone number format",
  "Loading...": "Loading...",
  "Lost your code? ": "Lost your code? ",
  "Network error": "Network error",
  "New Password": "New Password",
  "No account? ": "No account? ",
  "Resend a Code": "Resend a Code",
  "Reset password": "Reset password",
  "Sign In with AWS": "Sign In with AWS",
  "Sign Out": "Sign Out",
  "Sign Up": "Sign Up",
  "User already exists": "User already exists",
  "User does not exist": "User does not exist",
  "Username cannot be empty": "Username cannot be empty",
  "Username/client id combination not found.": "Username/client id combination not found.",
  "It may take a minute to arrive.": "It may take a minute to arrive.",
  "Your passwords must match": "Your passwords must match"
};

export const amplifyAuthBasePl = {
  "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
  "Back to Sign In": "Powrót do logowania",
  "Change Password": "Zmień hasło",
  "Confirm Password": "Potwierdź Hasło",
  "Confirm Sign Up": "Potwierdź rejestrację",
  "Confirm SMS Code": "Potwierdź kod SMS",
  "Confirm TOTP Code": "Potwierdź hasło jednorazowe",
  "Confirmation Code": "Kod potwierdzenia",
  "Create a new account": "Utwórz nowe konto",
  "Create Account": "Utwórz konto",
  "Creating Account": "Tworzenie konta",
  "Dismiss alert": "Zamknij alert",
  "Enter your code": "Wprowadź swój kod",
  "Enter your email": "Wpisz swój adres e-mail",
  "Enter your phone number": "Wpisz swój numer telefonu",
  "Enter your username": "Wprowadź swoją nazwę użytkownika",
  "Forgot your password?": "Zapomniałeś hasła? ",
  "Hide password": "Ukryj hasło",
  "It may take a minute to arrive": "Może to chwilę potrwać",
  "New password": "Nowe hasło",
  "Phone Number": "Numer telefonu",
  "Resend Code": "Wyślij kod ponownie",
  "Reset your password": "Zresetuj swoje hasło",
  "Reset your Password": "Zresetuj swoje hasło",
  "Send code": "Wyślij kod",
  "Send Code": "Zresetuj hasło",
  "Setup TOTP": "Konfiguruj TOTP",
  "Show password": "Pokaż hasło",
  "Sign in to your account": "Zaloguj się na swoje konto",
  "Sign In with Amazon": "Zaloguj z Amazon",
  "Sign In with Apple": "Zaloguj z Apple",
  "Sign In with Facebook": "Zaloguj z Facebook",
  "Sign In with Google": "Zaloguj z Google",
  "Sign In": "Logowanie",
  "Sign in": "Zaloguj",
  "Signing in": "Logowanie",
  "Verify Contact": "Weryfikacja danych kontaktowych",
  "Family Name": "Nazwisko",
  "Given Name": "Pierwsze imię",
  "Middle Name": "Drugie imię",
  "Preferred Username": "Preferowana nazwa użytkownika",
  "We Emailed You": "Wysłaliśmy Ci wiadomość e-mail",
  "We Sent A Code": "Wysłaliśmy kod",
  "We Texted You": "Wysłaliśmy Ci wiadomość SMS",
  "Your code is on the way. To log in, enter the code we emailed to": "Twój kod został wysłany. Aby się zalogować, wprowadź kod wysłany na adres e-mail",
  "Your code is on the way. To log in, enter the code we sent you": "Twój kod został wysłany. Aby się zalogować, wprowadź wysłany do Ciebie kod",
  "Your code is on the way. To log in, enter the code we texted to": "Twój kod został wysłany. Aby się zalogować, wprowadź kod wysłany do Ciebie w wiadomości SMS pod numer",
  "An account with the given email already exists.": "Konto z tym adresem e-mail już istnieje.",
  "Confirm a Code": "Potwierdź kod",
  "Confirm Sign In": "Potwierdź logowanie",
  "Create account": "Utwórz konto",
  "Enter your password": "Wprowadź hasło",
  "Forgot Password": "Zapomniałeś hasła?",
  "Have an account? ": "Masz już konto? ",
  "Incorrect username or password": "Nieprawidłowy adres e-mail lub hasło",
  "Incorrect username or password.": "Nieprawidłowy adres e-mail lub hasło.",
  "Invalid password format": "Nieprawidłowy format hasła",
  "Invalid phone number format": "Nieprawidłowy format numeru telefonu",
  "Loading...": "Ładowanie...",
  "Lost your code? ": "Nie otrzymałeś kodu? ",
  "Network error": "Błąd sieci",
  "New Password": "Nowe hasło",
  "No account? ": "Nie masz konta? ",
  "Resend a Code": "Wyślij kod ponownie",
  "Reset password": "Zresetuj hasło",
  "Sign In with AWS": "Zaloguj przez AWS",
  "Sign Out": "Wyloguj się",
  "Sign Up": "Zarejestruj się",
  "User already exists": "Użytkownik już istnieje",
  "User does not exist": "Użytkownik nie istnieje",
  "Username cannot be empty": "Adres e-mail nie może być pusty",
  "Username/client id combination not found.": "Nie znaleziono kombinacji użytkownika i identyfikatora klienta.",
  "It may take a minute to arrive.": "Dostarczenie może potrwać chwilę.",
  "Your passwords must match": "Hasła muszą być identyczne",
  "Forgot password?": "Zapomniałeś hasła?"
};
